var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpicyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52997 2.35201C8.05997 1.30201 7.77998 0.462026 7.47998 0.0520256C7.42998 -0.00797435 7.34999 -0.0179939 7.29999 0.0320061C7.29999 0.0320061 7.29998 0.0320159 7.28998 0.0420159L6.91998 0.44204C6.91998 0.44204 6.87002 0.562033 6.90002 0.622033C7.01002 0.802033 7.18 1.23204 6.88 1.88204C6.17 1.55204 5.35001 1.62204 4.70001 2.06204L5.91998 2.66201V4.03201H7.38L8.27002 5.022C8.33002 4.802 8.35999 4.57199 8.35999 4.33199C8.35999 3.57199 8.05998 2.852 7.53998 2.342L7.52997 2.35201ZM5.39001 4.592V3.022L4.52997 2.60201C3.56997 3.81201 3.21997 6.98202 0.909973 6.98202C0.399973 6.98202 0 7.422 0 7.962C0 8.502 0.409973 8.94204 0.909973 8.94204C4.37997 8.94204 6.96 6.792 7.75 5.272L7.15002 4.60201H5.40002L5.39001 4.592Z",
    fill: "#EF3E57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpicyIcon);
export default __webpack_public_path__ + "static/media/spicy-icon.87b731994f89b37818336113a77eddd4.svg";
export { ForwardRef as ReactComponent };